import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const farmerImage = 'https://cdn.magicpatterns.com/patterns/generated-images/152cb4a3-7e69-4915-99b2-6a7c4bc04be1.jpg';
const pastureImage = 'https://cdn.magicpatterns.com/patterns/generated-images/5c5b7af9-85c0-4a32-8813-8eb55bf2d64f.jpg';
const steps = [{
  title: 'La tonte',
  period: 'Avril — juin',
  text: 'Une tonte par an pour les brebis, deux pour les chèvres angora. Chaque toison est pesée et repérée au nom de l’animal.'
}, {
  title: 'Le tri et le lavage',
  period: 'Dans la foulée',
  text: 'Tri mèche par mèche à la table, puis lavage à l’eau de source. Le suint récupéré devient la lanoline de nos savons.'
}, {
  title: 'La filature',
  period: 'Été',
  text: 'La fibre part à 40 km, dans une filature aveyronnaise, pour être cardée, peignée et filée en pelotes ou en écheveaux.'
}, {
  title: 'La transformation à la ferme',
  period: 'Automne — hiver',
  text: 'Teintures végétales, tricot des chaussettes et écharpes, saponification à froid : tout revient à l’atelier.'
}];
export function Ferme() {
  return <div data-id="element-182" data-mp="u3dlab0m9nkv">
      <div className="mx-auto max-w-page px-5 pt-14 lg:px-8" data-id="element-183" data-mp="u33sygs3n4c0">
        <p className="text-sm text-muted" data-id="element-184" data-mp="u1j14yx65zhu">La ferme</p>
        <h1 className="mt-3 max-w-3xl font-display text-4xl leading-[1.1] text-ink sm:text-5xl" data-id="element-185" data-mp="p52b1z6etb24">
          90 hectares de causse, un troupeau, un atelier
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted" data-id="element-186" data-mp="l4iccr66tzdv">
          Le GAEC Bru de la Roque est installé sur les hauteurs de l’Aveyron. Audrey Jung y conduit
          180 brebis mérinos et 60 chèvres angora en pâturage tournant, et transforme l’intégralité de
          la fibre sur place ou à quelques kilomètres.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-page px-5 lg:px-8" data-id="element-187" data-mp="1deuaa2v3gdk">
        <img src={pastureImage} alt="Le troupeau en pâturage tournant sur le causse" className="aspect-[21/9] w-full rounded-lg object-cover" data-id="element-188" data-mp="3thz52c82y69y" />
      </div>

      <section className="mx-auto max-w-page px-5 py-20 lg:px-8" data-id="element-189" data-mp="3nw8ftaev0wul">
        <h2 className="font-display text-3xl text-ink" data-id="element-190" data-mp="3nudrrn8akoma">Le cycle de la fibre</h2>
        <ol className="mt-10 border-l border-line" data-id="element-191" data-mp="39ya123wmmyek">
          {steps.map((step, index) => <li key={step.title} className="relative grid gap-2 pb-10 pl-8 last:pb-0 md:grid-cols-[10rem_1fr] md:gap-8" data-id="element-192" data-mp="3ewbu9hnroe3r" data-mpi={index}>
              <span className="absolute -left-[9px] top-1 flex h-[18px] w-[18px] items-center justify-center rounded-full border border-line bg-cream text-[10px] font-semibold text-olive" data-id="element-193" data-mp="6i37wrbu8jk1">
                {index + 1}
              </span>
              <div data-id="element-194" data-mp="1oqjoib2mert">
                <h3 className="font-display text-xl text-ink" data-id="element-195" data-mp="1o8id79jxad1">{step.title}</h3>
                <p className="mt-1 text-sm text-muted" data-id="element-196" data-mp="peb4l6qsbm3q">{step.period}</p>
              </div>
              <p className="max-w-xl text-base leading-relaxed text-muted" data-id="element-197" data-mp="u5b4mkv7akag">{step.text}</p>
            </li>)}
        </ol>
      </section>

      <section className="bg-parchment" data-id="element-198" data-mp="13itouh1dwaqi">
        <div className="mx-auto grid max-w-page items-center gap-10 px-5 py-20 lg:grid-cols-[1.1fr_1fr] lg:px-8" data-id="element-199" data-mp="zirn67vnfhb8">
          <div data-id="element-200" data-mp="1dapkzmjwtqs3">
            <h2 className="font-display text-3xl leading-tight text-ink" data-id="element-201" data-mp="1d94qty1ic9ur">Audrey Jung</h2>
            <p className="mt-2 text-sm text-muted" data-id="element-202" data-mp="18atgznb7pzcj">Éleveuse, trieuse de toisons, savonnière</p>
            <p className="mt-6 text-base leading-relaxed text-muted" data-id="element-203" data-mp="kkz97k5r30z5">
              Fille et petite-fille d’éleveurs, Audrey reprend la ferme en 2009 avec l’idée de ne plus
              vendre la laine au poids. Elle se forme au tri et au classement des toisons, puis à la
              saponification à froid pour valoriser la lanoline. Les chèvres angora arrivent en 2019 pour
              compléter la gamme avec le mohair.
            </p>
            <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-204" data-mp="25x0n51n5zzr0">
              Aujourd’hui, elle accueille scolaires, curieux et fileuses sur la ferme, et défend une idée
              simple : une fibre qui a un nom, une origine et une saison.
            </p>
            <Link to="/visites" className="mt-7 inline-flex items-center gap-2 rounded-full bg-olive px-5 py-3 text-sm font-medium text-cream transition-colors duration-150 ease-soft hover:bg-olive-dark" data-id="element-205" data-mp="fisykoiygzx8">
              Venir la rencontrer
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="ti10vqaf0o5n" />
            </Link>
          </div>
          <img src={farmerImage} alt="Portrait d’Audrey Jung dans la bergerie" className="aspect-[3/4] w-full rounded-lg object-cover lg:max-w-sm lg:justify-self-end" loading="lazy" data-id="element-207" data-mp="yg2moiz871kt" />
        </div>
      </section>
    </div>;
}